import { default as _91slug_93uy34DkD4nHMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/categories/[slug].vue?macro=true";
import { default as _91slug_93ItWRAx3quTMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/manufacturers/[slug].vue?macro=true";
import { default as prescription_45uploadrtneugFh8LMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/prescription-upload.vue?macro=true";
import { default as _91pzn_93cTMpUw3sIQMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/product/[productName]/[pzn].vue?macro=true";
import { default as productstKWOGzKLldMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/products.vue?macro=true";
import { default as about_45ustEOi6mjb3fMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/about-us.vue?macro=true";
import { default as _91addressId_935HWvIBmpv2Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/billing-address/[addressId].vue?macro=true";
import { default as newYhQ8d3MgWUMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/billing-address/new.vue?macro=true";
import { default as _91token_931CZhhlZEgNMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/confirmation/not-verified/[id]/[secretKey]/[token].vue?macro=true";
import { default as _91secretKey_93l2vDVndJ1mMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/confirmation/verified/[id]/[secretKey].vue?macro=true";
import { default as requestm9Dd36CJsoMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/request.vue?macro=true";
import { default as sucessaJ9pXZoAcjMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/sucess.vue?macro=true";
import { default as change_45emailweQhoLbegiMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email.vue?macro=true";
import { default as change_45passwordRx2ovwOZnLMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-password.vue?macro=true";
import { default as data_45sharingCpwyjYjIAfMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/data-sharing.vue?macro=true";
import { default as _91addressId_93XIi89ydefkMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/delivery-address/[addressId].vue?macro=true";
import { default as newrGL1AhQLQsMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/delivery-address/new.vue?macro=true";
import { default as editPlloOpFWKkMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/edit.vue?macro=true";
import { default as ordersRmm8Xn7ZriMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/orders.vue?macro=true";
import { default as _91pzn_93cUsvGLvPqHMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/reorder/[orderId]/[pzn].vue?macro=true";
import { default as indexQm0ZZPPwJqMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/reorder/[orderId]/index.vue?macro=true";
import { default as _91userId_93szeyQbiYuXMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId].vue?macro=true";
import { default as optoutGRFYP5fYIuMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/optout.vue?macro=true";
import { default as b2b_45terms_45of_45useF0VRUdirqSMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/b2b-terms-of-use.vue?macro=true";
import { default as _91slug_93PrLtC4epOjMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/brand/[slug].vue?macro=true";
import { default as branddYvynfl1utMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/brand.vue?macro=true";
import { default as careerBepgV5ZqwSMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/career.vue?macro=true";
import { default as _91slug_93uQlFmsei7FMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/category/[slug].vue?macro=true";
import { default as _91draftId_933N8XMi3R4wMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/cart/[draftId].vue?macro=true";
import { default as indexF7F2YClA6cMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/cart/index.vue?macro=true";
import { default as _91draftId_93VcS9ajAkJsMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/confirmation/[draftId].vue?macro=true";
import { default as _91draftId_93AKIPzmDSABMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/customer/[draftId].vue?macro=true";
import { default as _91draftId_93iyxaIIweF7Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/delivery/[draftId].vue?macro=true";
import { default as _91draftId_936UTozYDiahMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/overview/[draftId].vue?macro=true";
import { default as _91draftId_93jHsEaYKPDeMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/payment/[draftId].vue?macro=true";
import { default as contactDm1VwxJ2DTMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/contact.vue?macro=true";
import { default as corona_45enBTZg8dX5SLMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/corona-en.vue?macro=true";
import { default as archive_45magazineUYQ91wUO7YMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/archive-magazine.vue?macro=true";
import { default as index2AhX13BOA3Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/index.vue?macro=true";
import { default as indexm07MYSLHIJMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/login/index.vue?macro=true";
import { default as magazineM0CxO4FrnMMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/magazine.vue?macro=true";
import { default as indexzKa5HA6SYcMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/register/index.vue?macro=true";
import { default as successILOp9nwjGzMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/register/success.vue?macro=true";
import { default as indexFPldh7IYOIMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/subscribe/index.vue?macro=true";
import { default as successzOgEIc6ZJEMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/subscribe/success.vue?macro=true";
import { default as indexHrYGoMP0SdMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/unsubscribe/index.vue?macro=true";
import { default as express_45deliveryNgA0XN1uSVMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/express-delivery.vue?macro=true";
import { default as faq_45env56tio3QgfMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/faq-en.vue?macro=true";
import { default as find_45pharmacyTu75v5hs2RMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/find-pharmacy.vue?macro=true";
import { default as hiv_45self_45testO2SnylvHPHMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/hiv-self-test.vue?macro=true";
import { default as imprintLZGiH4R1Z8Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/imprint.vue?macro=true";
import { default as indexjKsKujG71KMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/index.vue?macro=true";
import { default as login_45enbtG3bhYamKMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/login-en.vue?macro=true";
import { default as logoutdh5kyPF7fPMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/logout.vue?macro=true";
import { default as _91slug_93wlMddoA6QVMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/manufacturers/[slug].vue?macro=true";
import { default as newsletter_45enQNHCSyAwUUMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/newsletter-en.vue?macro=true";
import { default as pharmacy_45finderq6kkAuAdQUMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy-finder.vue?macro=true";
import { default as _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[...pharmacyName]-[pharmacyPlz]-[pharmacyId].vue?macro=true";
import { default as _91slug_93bvMtV2K17cMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/brand/[slug].vue?macro=true";
import { default as contact_45pharmacyGY5AVXdupeMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/contact-pharmacy.vue?macro=true";
import { default as express_45deliverytYPUSvkDoeMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/express-delivery.vue?macro=true";
import { default as _91slug_93SextJPAErRMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/topic/[slug].vue?macro=true";
import { default as prescription_45uploadBQAUDYMK7hMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/prescription-upload.vue?macro=true";
import { default as privacy_45policyFLzoNrKVOwMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/privacy-policy.vue?macro=true";
import { default as _91pzn_93HA2hzLuHsPMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/product/[productName]/[pzn].vue?macro=true";
import { default as productslXxUFvAZCpMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/products.vue?macro=true";
import { default as register_45enwkCm91By9GMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register-en.vue?macro=true";
import { default as _91token_93dhxKPNZxuRMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-crm-en/[token].vue?macro=true";
import { default as _91pharmacyId_93c3fMDKG0zVMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-crm-link-existing/[customerNumber]/[pharmacyId].vue?macro=true";
import { default as _91token_934gxUM9QUqCMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-en/[token].vue?macro=true";
import { default as requestIYKz0yNNd4Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/resetting/request.vue?macro=true";
import { default as _91token_93bnBPol3kk5Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/resetting/reset/[token].vue?macro=true";
import { default as searchzTV48k1fLwMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/search.vue?macro=true";
import { default as terms_45of_45useLVN2v29mupMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/terms-of-use.vue?macro=true";
import { default as test_45page_45fec2EBFa7W3u3vMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/test-page-fec2.vue?macro=true";
import { default as _91slug_934vzq28VdIzMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/topic/[slug].vue?macro=true";
import { default as topicfjgxvUGkM4Meta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/topic.vue?macro=true";
import { default as whatsapp_45create_45cartPgOFtB9JknMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/whatsapp-create-cart.vue?macro=true";
import { default as whatsapp_45privacy_45policy93Zui3Q4rcMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/whatsapp-privacy-policy.vue?macro=true";
import { default as partner_45shopxXLFlAm8oIMeta } from "/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/widgets-en/partner-shop.vue?macro=true";
export default [
  {
    name: _91slug_93uy34DkD4nHMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-categories-slug",
    path: _91slug_93uy34DkD4nHMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz()-:pharmacyId()/categories/:slug()",
    meta: _91slug_93uy34DkD4nHMeta || {},
    alias: _91slug_93uy34DkD4nHMeta?.alias || [],
    redirect: _91slug_93uy34DkD4nHMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/categories/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ItWRAx3quTMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-manufacturers-slug",
    path: _91slug_93ItWRAx3quTMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz()-:pharmacyId()/manufacturers/:slug()",
    meta: _91slug_93ItWRAx3quTMeta || {},
    alias: _91slug_93ItWRAx3quTMeta?.alias || [],
    redirect: _91slug_93ItWRAx3quTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/manufacturers/[slug].vue").then(m => m.default || m)
  },
  {
    name: prescription_45uploadrtneugFh8LMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-prescription-upload",
    path: prescription_45uploadrtneugFh8LMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz()-:pharmacyId()/prescription-upload",
    meta: prescription_45uploadrtneugFh8LMeta || {},
    alias: prescription_45uploadrtneugFh8LMeta?.alias || [],
    redirect: prescription_45uploadrtneugFh8LMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/prescription-upload.vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93cTMpUw3sIQMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-product-productName-pzn",
    path: _91pzn_93cTMpUw3sIQMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz()-:pharmacyId()/product/:productName()/:pzn()",
    meta: _91pzn_93cTMpUw3sIQMeta || {},
    alias: _91pzn_93cTMpUw3sIQMeta?.alias || [],
    redirect: _91pzn_93cTMpUw3sIQMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/product/[productName]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: productstKWOGzKLldMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-products",
    path: productstKWOGzKLldMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz()-:pharmacyId()/products",
    meta: productstKWOGzKLldMeta || {},
    alias: productstKWOGzKLldMeta?.alias || [],
    redirect: productstKWOGzKLldMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/products.vue").then(m => m.default || m)
  },
  {
    name: about_45ustEOi6mjb3fMeta?.name ?? "about-us",
    path: about_45ustEOi6mjb3fMeta?.path ?? "/about-us",
    meta: about_45ustEOi6mjb3fMeta || {},
    alias: about_45ustEOi6mjb3fMeta?.alias || [],
    redirect: about_45ustEOi6mjb3fMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: _91userId_93szeyQbiYuXMeta?.name ?? "account-userId",
    path: _91userId_93szeyQbiYuXMeta?.path ?? "/account/:userId()",
    children: [
  {
    name: _91addressId_935HWvIBmpv2Meta?.name ?? "account-userId-billing-address-addressId",
    path: _91addressId_935HWvIBmpv2Meta?.path ?? "billing-address/:addressId()",
    meta: _91addressId_935HWvIBmpv2Meta || {},
    alias: _91addressId_935HWvIBmpv2Meta?.alias || [],
    redirect: _91addressId_935HWvIBmpv2Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/billing-address/[addressId].vue").then(m => m.default || m)
  },
  {
    name: newYhQ8d3MgWUMeta?.name ?? "account-userId-billing-address-new",
    path: newYhQ8d3MgWUMeta?.path ?? "billing-address/new",
    meta: newYhQ8d3MgWUMeta || {},
    alias: newYhQ8d3MgWUMeta?.alias || [],
    redirect: newYhQ8d3MgWUMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/billing-address/new.vue").then(m => m.default || m)
  },
  {
    name: change_45emailweQhoLbegiMeta?.name ?? "account-userId-change-email",
    path: change_45emailweQhoLbegiMeta?.path ?? "change-email",
    children: [
  {
    name: _91token_931CZhhlZEgNMeta?.name ?? "account-userId-change-email-confirmation-not-verified-id-secretKey-token",
    path: _91token_931CZhhlZEgNMeta?.path ?? "confirmation/not-verified/:id()/:secretKey()/:token()",
    meta: _91token_931CZhhlZEgNMeta || {},
    alias: _91token_931CZhhlZEgNMeta?.alias || [],
    redirect: _91token_931CZhhlZEgNMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/confirmation/not-verified/[id]/[secretKey]/[token].vue").then(m => m.default || m)
  },
  {
    name: _91secretKey_93l2vDVndJ1mMeta?.name ?? "account-userId-change-email-confirmation-verified-id-secretKey",
    path: _91secretKey_93l2vDVndJ1mMeta?.path ?? "confirmation/verified/:id()/:secretKey()",
    meta: _91secretKey_93l2vDVndJ1mMeta || {},
    alias: _91secretKey_93l2vDVndJ1mMeta?.alias || [],
    redirect: _91secretKey_93l2vDVndJ1mMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/confirmation/verified/[id]/[secretKey].vue").then(m => m.default || m)
  },
  {
    name: requestm9Dd36CJsoMeta?.name ?? "account-userId-change-email-request",
    path: requestm9Dd36CJsoMeta?.path ?? "request",
    meta: requestm9Dd36CJsoMeta || {},
    alias: requestm9Dd36CJsoMeta?.alias || [],
    redirect: requestm9Dd36CJsoMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/request.vue").then(m => m.default || m)
  },
  {
    name: sucessaJ9pXZoAcjMeta?.name ?? "account-userId-change-email-sucess",
    path: sucessaJ9pXZoAcjMeta?.path ?? "sucess",
    meta: sucessaJ9pXZoAcjMeta || {},
    alias: sucessaJ9pXZoAcjMeta?.alias || [],
    redirect: sucessaJ9pXZoAcjMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/sucess.vue").then(m => m.default || m)
  }
],
    meta: change_45emailweQhoLbegiMeta || {},
    alias: change_45emailweQhoLbegiMeta?.alias || [],
    redirect: change_45emailweQhoLbegiMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email.vue").then(m => m.default || m)
  },
  {
    name: change_45passwordRx2ovwOZnLMeta?.name ?? "account-userId-change-password",
    path: change_45passwordRx2ovwOZnLMeta?.path ?? "change-password",
    meta: change_45passwordRx2ovwOZnLMeta || {},
    alias: change_45passwordRx2ovwOZnLMeta?.alias || [],
    redirect: change_45passwordRx2ovwOZnLMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-password.vue").then(m => m.default || m)
  },
  {
    name: data_45sharingCpwyjYjIAfMeta?.name ?? "account-userId-data-sharing",
    path: data_45sharingCpwyjYjIAfMeta?.path ?? "data-sharing",
    meta: data_45sharingCpwyjYjIAfMeta || {},
    alias: data_45sharingCpwyjYjIAfMeta?.alias || [],
    redirect: data_45sharingCpwyjYjIAfMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/data-sharing.vue").then(m => m.default || m)
  },
  {
    name: _91addressId_93XIi89ydefkMeta?.name ?? "account-userId-delivery-address-addressId",
    path: _91addressId_93XIi89ydefkMeta?.path ?? "delivery-address/:addressId()",
    meta: _91addressId_93XIi89ydefkMeta || {},
    alias: _91addressId_93XIi89ydefkMeta?.alias || [],
    redirect: _91addressId_93XIi89ydefkMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/delivery-address/[addressId].vue").then(m => m.default || m)
  },
  {
    name: newrGL1AhQLQsMeta?.name ?? "account-userId-delivery-address-new",
    path: newrGL1AhQLQsMeta?.path ?? "delivery-address/new",
    meta: newrGL1AhQLQsMeta || {},
    alias: newrGL1AhQLQsMeta?.alias || [],
    redirect: newrGL1AhQLQsMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/delivery-address/new.vue").then(m => m.default || m)
  },
  {
    name: editPlloOpFWKkMeta?.name ?? "account-userId-edit",
    path: editPlloOpFWKkMeta?.path ?? "edit",
    meta: editPlloOpFWKkMeta || {},
    alias: editPlloOpFWKkMeta?.alias || [],
    redirect: editPlloOpFWKkMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/edit.vue").then(m => m.default || m)
  },
  {
    name: ordersRmm8Xn7ZriMeta?.name ?? "account-userId-orders",
    path: ordersRmm8Xn7ZriMeta?.path ?? "orders",
    meta: ordersRmm8Xn7ZriMeta || {},
    alias: ordersRmm8Xn7ZriMeta?.alias || [],
    redirect: ordersRmm8Xn7ZriMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/orders.vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93cUsvGLvPqHMeta?.name ?? "account-userId-reorder-orderId-pzn",
    path: _91pzn_93cUsvGLvPqHMeta?.path ?? "reorder/:orderId()/:pzn()",
    meta: _91pzn_93cUsvGLvPqHMeta || {},
    alias: _91pzn_93cUsvGLvPqHMeta?.alias || [],
    redirect: _91pzn_93cUsvGLvPqHMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/reorder/[orderId]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: indexQm0ZZPPwJqMeta?.name ?? "account-userId-reorder-orderId",
    path: indexQm0ZZPPwJqMeta?.path ?? "reorder/:orderId()",
    meta: indexQm0ZZPPwJqMeta || {},
    alias: indexQm0ZZPPwJqMeta?.alias || [],
    redirect: indexQm0ZZPPwJqMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/reorder/[orderId]/index.vue").then(m => m.default || m)
  }
],
    meta: _91userId_93szeyQbiYuXMeta || {},
    alias: _91userId_93szeyQbiYuXMeta?.alias || [],
    redirect: _91userId_93szeyQbiYuXMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId].vue").then(m => m.default || m)
  },
  {
    name: optoutGRFYP5fYIuMeta?.name ?? "account-optout",
    path: optoutGRFYP5fYIuMeta?.path ?? "/account/optout",
    meta: optoutGRFYP5fYIuMeta || {},
    alias: optoutGRFYP5fYIuMeta?.alias || [],
    redirect: optoutGRFYP5fYIuMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/optout.vue").then(m => m.default || m)
  },
  {
    name: b2b_45terms_45of_45useF0VRUdirqSMeta?.name ?? "b2b-terms-of-use",
    path: b2b_45terms_45of_45useF0VRUdirqSMeta?.path ?? "/b2b-terms-of-use",
    meta: b2b_45terms_45of_45useF0VRUdirqSMeta || {},
    alias: b2b_45terms_45of_45useF0VRUdirqSMeta?.alias || [],
    redirect: b2b_45terms_45of_45useF0VRUdirqSMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/b2b-terms-of-use.vue").then(m => m.default || m)
  },
  {
    name: branddYvynfl1utMeta?.name ?? "brand",
    path: branddYvynfl1utMeta?.path ?? "/brand",
    children: [
  {
    name: _91slug_93PrLtC4epOjMeta?.name ?? "brand-slug",
    path: _91slug_93PrLtC4epOjMeta?.path ?? ":slug()",
    meta: _91slug_93PrLtC4epOjMeta || {},
    alias: _91slug_93PrLtC4epOjMeta?.alias || [],
    redirect: _91slug_93PrLtC4epOjMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/brand/[slug].vue").then(m => m.default || m)
  }
],
    meta: branddYvynfl1utMeta || {},
    alias: branddYvynfl1utMeta?.alias || [],
    redirect: branddYvynfl1utMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/brand.vue").then(m => m.default || m)
  },
  {
    name: careerBepgV5ZqwSMeta?.name ?? "career",
    path: careerBepgV5ZqwSMeta?.path ?? "/career",
    meta: careerBepgV5ZqwSMeta || {},
    alias: careerBepgV5ZqwSMeta?.alias || [],
    redirect: careerBepgV5ZqwSMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/career.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93uQlFmsei7FMeta?.name ?? "category-slug",
    path: _91slug_93uQlFmsei7FMeta?.path ?? "/category/:slug()",
    meta: _91slug_93uQlFmsei7FMeta || {},
    alias: _91slug_93uQlFmsei7FMeta?.alias || [],
    redirect: _91slug_93uQlFmsei7FMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/category/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_933N8XMi3R4wMeta?.name ?? "checkout-cart-draftId",
    path: _91draftId_933N8XMi3R4wMeta?.path ?? "/checkout/cart/:draftId()",
    meta: _91draftId_933N8XMi3R4wMeta || {},
    alias: _91draftId_933N8XMi3R4wMeta?.alias || [],
    redirect: _91draftId_933N8XMi3R4wMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/cart/[draftId].vue").then(m => m.default || m)
  },
  {
    name: indexF7F2YClA6cMeta?.name ?? "checkout-cart",
    path: indexF7F2YClA6cMeta?.path ?? "/checkout/cart",
    meta: indexF7F2YClA6cMeta || {},
    alias: indexF7F2YClA6cMeta?.alias || [],
    redirect: indexF7F2YClA6cMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93VcS9ajAkJsMeta?.name ?? "checkout-confirmation-draftId",
    path: _91draftId_93VcS9ajAkJsMeta?.path ?? "/checkout/confirmation/:draftId()",
    meta: _91draftId_93VcS9ajAkJsMeta || {},
    alias: _91draftId_93VcS9ajAkJsMeta?.alias || [],
    redirect: _91draftId_93VcS9ajAkJsMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/confirmation/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93AKIPzmDSABMeta?.name ?? "checkout-customer-draftId",
    path: _91draftId_93AKIPzmDSABMeta?.path ?? "/checkout/customer/:draftId()",
    meta: _91draftId_93AKIPzmDSABMeta || {},
    alias: _91draftId_93AKIPzmDSABMeta?.alias || [],
    redirect: _91draftId_93AKIPzmDSABMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/customer/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93iyxaIIweF7Meta?.name ?? "checkout-delivery-draftId",
    path: _91draftId_93iyxaIIweF7Meta?.path ?? "/checkout/delivery/:draftId()",
    meta: _91draftId_93iyxaIIweF7Meta || {},
    alias: _91draftId_93iyxaIIweF7Meta?.alias || [],
    redirect: _91draftId_93iyxaIIweF7Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/delivery/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_936UTozYDiahMeta?.name ?? "checkout-overview-draftId",
    path: _91draftId_936UTozYDiahMeta?.path ?? "/checkout/overview/:draftId()",
    meta: _91draftId_936UTozYDiahMeta || {},
    alias: _91draftId_936UTozYDiahMeta?.alias || [],
    redirect: _91draftId_936UTozYDiahMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/overview/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93jHsEaYKPDeMeta?.name ?? "checkout-payment-draftId",
    path: _91draftId_93jHsEaYKPDeMeta?.path ?? "/checkout/payment/:draftId()",
    meta: _91draftId_93jHsEaYKPDeMeta || {},
    alias: _91draftId_93jHsEaYKPDeMeta?.alias || [],
    redirect: _91draftId_93jHsEaYKPDeMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/payment/[draftId].vue").then(m => m.default || m)
  },
  {
    name: contactDm1VwxJ2DTMeta?.name ?? "contact",
    path: contactDm1VwxJ2DTMeta?.path ?? "/contact",
    meta: contactDm1VwxJ2DTMeta || {},
    alias: contactDm1VwxJ2DTMeta?.alias || [],
    redirect: contactDm1VwxJ2DTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: corona_45enBTZg8dX5SLMeta?.name ?? "corona-en",
    path: corona_45enBTZg8dX5SLMeta?.path ?? "/corona-en",
    meta: corona_45enBTZg8dX5SLMeta || {},
    alias: corona_45enBTZg8dX5SLMeta?.alias || [],
    redirect: corona_45enBTZg8dX5SLMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/corona-en.vue").then(m => m.default || m)
  },
  {
    name: archive_45magazineUYQ91wUO7YMeta?.name ?? "epaper-en-archive-magazine",
    path: archive_45magazineUYQ91wUO7YMeta?.path ?? "/epaper-en/archive-magazine",
    meta: archive_45magazineUYQ91wUO7YMeta || {},
    alias: archive_45magazineUYQ91wUO7YMeta?.alias || [],
    redirect: archive_45magazineUYQ91wUO7YMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/archive-magazine.vue").then(m => m.default || m)
  },
  {
    name: index2AhX13BOA3Meta?.name ?? "epaper-en",
    path: index2AhX13BOA3Meta?.path ?? "/epaper-en",
    meta: index2AhX13BOA3Meta || {},
    alias: index2AhX13BOA3Meta?.alias || [],
    redirect: index2AhX13BOA3Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/index.vue").then(m => m.default || m)
  },
  {
    name: indexm07MYSLHIJMeta?.name ?? "epaper-en-login",
    path: indexm07MYSLHIJMeta?.path ?? "/epaper-en/login",
    meta: indexm07MYSLHIJMeta || {},
    alias: indexm07MYSLHIJMeta?.alias || [],
    redirect: indexm07MYSLHIJMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/login/index.vue").then(m => m.default || m)
  },
  {
    name: magazineM0CxO4FrnMMeta?.name ?? "epaper-en-magazine",
    path: magazineM0CxO4FrnMMeta?.path ?? "/epaper-en/magazine",
    meta: magazineM0CxO4FrnMMeta || {},
    alias: magazineM0CxO4FrnMMeta?.alias || [],
    redirect: magazineM0CxO4FrnMMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/magazine.vue").then(m => m.default || m)
  },
  {
    name: indexzKa5HA6SYcMeta?.name ?? "epaper-en-register",
    path: indexzKa5HA6SYcMeta?.path ?? "/epaper-en/register",
    meta: indexzKa5HA6SYcMeta || {},
    alias: indexzKa5HA6SYcMeta?.alias || [],
    redirect: indexzKa5HA6SYcMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/register/index.vue").then(m => m.default || m)
  },
  {
    name: successILOp9nwjGzMeta?.name ?? "epaper-en-register-success",
    path: successILOp9nwjGzMeta?.path ?? "/epaper-en/register/success",
    meta: successILOp9nwjGzMeta || {},
    alias: successILOp9nwjGzMeta?.alias || [],
    redirect: successILOp9nwjGzMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/register/success.vue").then(m => m.default || m)
  },
  {
    name: indexFPldh7IYOIMeta?.name ?? "epaper-en-subscribe",
    path: indexFPldh7IYOIMeta?.path ?? "/epaper-en/subscribe",
    meta: indexFPldh7IYOIMeta || {},
    alias: indexFPldh7IYOIMeta?.alias || [],
    redirect: indexFPldh7IYOIMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/subscribe/index.vue").then(m => m.default || m)
  },
  {
    name: successzOgEIc6ZJEMeta?.name ?? "epaper-en-subscribe-success",
    path: successzOgEIc6ZJEMeta?.path ?? "/epaper-en/subscribe/success",
    meta: successzOgEIc6ZJEMeta || {},
    alias: successzOgEIc6ZJEMeta?.alias || [],
    redirect: successzOgEIc6ZJEMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/subscribe/success.vue").then(m => m.default || m)
  },
  {
    name: indexHrYGoMP0SdMeta?.name ?? "epaper-en-unsubscribe",
    path: indexHrYGoMP0SdMeta?.path ?? "/epaper-en/unsubscribe",
    meta: indexHrYGoMP0SdMeta || {},
    alias: indexHrYGoMP0SdMeta?.alias || [],
    redirect: indexHrYGoMP0SdMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: express_45deliveryNgA0XN1uSVMeta?.name ?? "express-delivery",
    path: express_45deliveryNgA0XN1uSVMeta?.path ?? "/express-delivery",
    meta: express_45deliveryNgA0XN1uSVMeta || {},
    alias: express_45deliveryNgA0XN1uSVMeta?.alias || [],
    redirect: express_45deliveryNgA0XN1uSVMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/express-delivery.vue").then(m => m.default || m)
  },
  {
    name: faq_45env56tio3QgfMeta?.name ?? "faq-en",
    path: faq_45env56tio3QgfMeta?.path ?? "/faq-en",
    meta: faq_45env56tio3QgfMeta || {},
    alias: faq_45env56tio3QgfMeta?.alias || [],
    redirect: faq_45env56tio3QgfMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/faq-en.vue").then(m => m.default || m)
  },
  {
    name: find_45pharmacyTu75v5hs2RMeta?.name ?? "find-pharmacy",
    path: find_45pharmacyTu75v5hs2RMeta?.path ?? "/find-pharmacy",
    meta: find_45pharmacyTu75v5hs2RMeta || {},
    alias: find_45pharmacyTu75v5hs2RMeta?.alias || [],
    redirect: find_45pharmacyTu75v5hs2RMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/find-pharmacy.vue").then(m => m.default || m)
  },
  {
    name: hiv_45self_45testO2SnylvHPHMeta?.name ?? "hiv-self-test",
    path: hiv_45self_45testO2SnylvHPHMeta?.path ?? "/hiv-self-test",
    meta: hiv_45self_45testO2SnylvHPHMeta || {},
    alias: hiv_45self_45testO2SnylvHPHMeta?.alias || [],
    redirect: hiv_45self_45testO2SnylvHPHMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/hiv-self-test.vue").then(m => m.default || m)
  },
  {
    name: imprintLZGiH4R1Z8Meta?.name ?? "imprint",
    path: imprintLZGiH4R1Z8Meta?.path ?? "/imprint",
    meta: imprintLZGiH4R1Z8Meta || {},
    alias: imprintLZGiH4R1Z8Meta?.alias || [],
    redirect: imprintLZGiH4R1Z8Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/imprint.vue").then(m => m.default || m)
  },
  {
    name: indexjKsKujG71KMeta?.name ?? "index",
    path: indexjKsKujG71KMeta?.path ?? "/",
    meta: indexjKsKujG71KMeta || {},
    alias: indexjKsKujG71KMeta?.alias || [],
    redirect: indexjKsKujG71KMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: login_45enbtG3bhYamKMeta?.name ?? "login-en",
    path: login_45enbtG3bhYamKMeta?.path ?? "/login-en",
    meta: login_45enbtG3bhYamKMeta || {},
    alias: login_45enbtG3bhYamKMeta?.alias || [],
    redirect: login_45enbtG3bhYamKMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/login-en.vue").then(m => m.default || m)
  },
  {
    name: logoutdh5kyPF7fPMeta?.name ?? "logout",
    path: logoutdh5kyPF7fPMeta?.path ?? "/logout",
    meta: logoutdh5kyPF7fPMeta || {},
    alias: logoutdh5kyPF7fPMeta?.alias || [],
    redirect: logoutdh5kyPF7fPMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wlMddoA6QVMeta?.name ?? "manufacturers-slug",
    path: _91slug_93wlMddoA6QVMeta?.path ?? "/manufacturers/:slug()",
    meta: _91slug_93wlMddoA6QVMeta || {},
    alias: _91slug_93wlMddoA6QVMeta?.alias || [],
    redirect: _91slug_93wlMddoA6QVMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/manufacturers/[slug].vue").then(m => m.default || m)
  },
  {
    name: newsletter_45enQNHCSyAwUUMeta?.name ?? "newsletter-en",
    path: newsletter_45enQNHCSyAwUUMeta?.path ?? "/newsletter-en",
    meta: newsletter_45enQNHCSyAwUUMeta || {},
    alias: newsletter_45enQNHCSyAwUUMeta?.alias || [],
    redirect: newsletter_45enQNHCSyAwUUMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/newsletter-en.vue").then(m => m.default || m)
  },
  {
    name: pharmacy_45finderq6kkAuAdQUMeta?.name ?? "pharmacy-finder",
    path: pharmacy_45finderq6kkAuAdQUMeta?.path ?? "/pharmacy-finder",
    meta: pharmacy_45finderq6kkAuAdQUMeta || {},
    alias: pharmacy_45finderq6kkAuAdQUMeta?.alias || [],
    redirect: pharmacy_45finderq6kkAuAdQUMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy-finder.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.name ?? "pharmacy-pharmacyName-pharmacyPlz-pharmacyId",
    path: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.path ?? "/pharmacy/:pharmacyName(.*)*-:pharmacyPlz()-:pharmacyId()",
    meta: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta || {},
    alias: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.alias || [],
    redirect: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[...pharmacyName]-[pharmacyPlz]-[pharmacyId].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93bvMtV2K17cMeta?.name ?? "pharmacy-pharmacyId-brand-slug",
    path: _91slug_93bvMtV2K17cMeta?.path ?? "/pharmacy/:pharmacyId()/brand/:slug()",
    meta: _91slug_93bvMtV2K17cMeta || {},
    alias: _91slug_93bvMtV2K17cMeta?.alias || [],
    redirect: _91slug_93bvMtV2K17cMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/brand/[slug].vue").then(m => m.default || m)
  },
  {
    name: contact_45pharmacyGY5AVXdupeMeta?.name ?? "pharmacy-pharmacyId-contact-pharmacy",
    path: contact_45pharmacyGY5AVXdupeMeta?.path ?? "/pharmacy/:pharmacyId()/contact-pharmacy",
    meta: contact_45pharmacyGY5AVXdupeMeta || {},
    alias: contact_45pharmacyGY5AVXdupeMeta?.alias || [],
    redirect: contact_45pharmacyGY5AVXdupeMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/contact-pharmacy.vue").then(m => m.default || m)
  },
  {
    name: express_45deliverytYPUSvkDoeMeta?.name ?? "pharmacy-pharmacyId-express-delivery",
    path: express_45deliverytYPUSvkDoeMeta?.path ?? "/pharmacy/:pharmacyId()/express-delivery",
    meta: express_45deliverytYPUSvkDoeMeta || {},
    alias: express_45deliverytYPUSvkDoeMeta?.alias || [],
    redirect: express_45deliverytYPUSvkDoeMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/express-delivery.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93SextJPAErRMeta?.name ?? "pharmacy-pharmacyId-topic-slug",
    path: _91slug_93SextJPAErRMeta?.path ?? "/pharmacy/:pharmacyId()/topic/:slug()",
    meta: _91slug_93SextJPAErRMeta || {},
    alias: _91slug_93SextJPAErRMeta?.alias || [],
    redirect: _91slug_93SextJPAErRMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/topic/[slug].vue").then(m => m.default || m)
  },
  {
    name: prescription_45uploadBQAUDYMK7hMeta?.name ?? "prescription-upload",
    path: prescription_45uploadBQAUDYMK7hMeta?.path ?? "/prescription-upload",
    meta: prescription_45uploadBQAUDYMK7hMeta || {},
    alias: prescription_45uploadBQAUDYMK7hMeta?.alias || [],
    redirect: prescription_45uploadBQAUDYMK7hMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/prescription-upload.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFLzoNrKVOwMeta?.name ?? "privacy-policy",
    path: privacy_45policyFLzoNrKVOwMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyFLzoNrKVOwMeta || {},
    alias: privacy_45policyFLzoNrKVOwMeta?.alias || [],
    redirect: privacy_45policyFLzoNrKVOwMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93HA2hzLuHsPMeta?.name ?? "product-productName-pzn",
    path: _91pzn_93HA2hzLuHsPMeta?.path ?? "/product/:productName()/:pzn()",
    meta: _91pzn_93HA2hzLuHsPMeta || {},
    alias: _91pzn_93HA2hzLuHsPMeta?.alias || [],
    redirect: _91pzn_93HA2hzLuHsPMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/product/[productName]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: productslXxUFvAZCpMeta?.name ?? "products",
    path: productslXxUFvAZCpMeta?.path ?? "/products",
    meta: productslXxUFvAZCpMeta || {},
    alias: productslXxUFvAZCpMeta?.alias || [],
    redirect: productslXxUFvAZCpMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/products.vue").then(m => m.default || m)
  },
  {
    name: register_45enwkCm91By9GMeta?.name ?? "register-en",
    path: register_45enwkCm91By9GMeta?.path ?? "/register-en",
    meta: register_45enwkCm91By9GMeta || {},
    alias: register_45enwkCm91By9GMeta?.alias || [],
    redirect: register_45enwkCm91By9GMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register-en.vue").then(m => m.default || m)
  },
  {
    name: _91token_93dhxKPNZxuRMeta?.name ?? "register-confirm-crm-en-token",
    path: _91token_93dhxKPNZxuRMeta?.path ?? "/register/confirm-crm-en/:token()",
    meta: _91token_93dhxKPNZxuRMeta || {},
    alias: _91token_93dhxKPNZxuRMeta?.alias || [],
    redirect: _91token_93dhxKPNZxuRMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-crm-en/[token].vue").then(m => m.default || m)
  },
  {
    name: _91pharmacyId_93c3fMDKG0zVMeta?.name ?? "register-confirm-crm-link-existing-customerNumber-pharmacyId",
    path: _91pharmacyId_93c3fMDKG0zVMeta?.path ?? "/register/confirm-crm-link-existing/:customerNumber()/:pharmacyId()",
    meta: _91pharmacyId_93c3fMDKG0zVMeta || {},
    alias: _91pharmacyId_93c3fMDKG0zVMeta?.alias || [],
    redirect: _91pharmacyId_93c3fMDKG0zVMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-crm-link-existing/[customerNumber]/[pharmacyId].vue").then(m => m.default || m)
  },
  {
    name: _91token_934gxUM9QUqCMeta?.name ?? "register-confirm-en-token",
    path: _91token_934gxUM9QUqCMeta?.path ?? "/register/confirm-en/:token()",
    meta: _91token_934gxUM9QUqCMeta || {},
    alias: _91token_934gxUM9QUqCMeta?.alias || [],
    redirect: _91token_934gxUM9QUqCMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-en/[token].vue").then(m => m.default || m)
  },
  {
    name: requestIYKz0yNNd4Meta?.name ?? "resetting-request",
    path: requestIYKz0yNNd4Meta?.path ?? "/resetting/request",
    meta: requestIYKz0yNNd4Meta || {},
    alias: requestIYKz0yNNd4Meta?.alias || [],
    redirect: requestIYKz0yNNd4Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/resetting/request.vue").then(m => m.default || m)
  },
  {
    name: _91token_93bnBPol3kk5Meta?.name ?? "resetting-reset-token",
    path: _91token_93bnBPol3kk5Meta?.path ?? "/resetting/reset/:token()",
    meta: _91token_93bnBPol3kk5Meta || {},
    alias: _91token_93bnBPol3kk5Meta?.alias || [],
    redirect: _91token_93bnBPol3kk5Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/resetting/reset/[token].vue").then(m => m.default || m)
  },
  {
    name: searchzTV48k1fLwMeta?.name ?? "search",
    path: searchzTV48k1fLwMeta?.path ?? "/search",
    meta: searchzTV48k1fLwMeta || {},
    alias: searchzTV48k1fLwMeta?.alias || [],
    redirect: searchzTV48k1fLwMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/search.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45useLVN2v29mupMeta?.name ?? "terms-of-use",
    path: terms_45of_45useLVN2v29mupMeta?.path ?? "/terms-of-use",
    meta: terms_45of_45useLVN2v29mupMeta || {},
    alias: terms_45of_45useLVN2v29mupMeta?.alias || [],
    redirect: terms_45of_45useLVN2v29mupMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/terms-of-use.vue").then(m => m.default || m)
  },
  {
    name: test_45page_45fec2EBFa7W3u3vMeta?.name ?? "test-page-fec2",
    path: test_45page_45fec2EBFa7W3u3vMeta?.path ?? "/test-page-fec2",
    meta: test_45page_45fec2EBFa7W3u3vMeta || {},
    alias: test_45page_45fec2EBFa7W3u3vMeta?.alias || [],
    redirect: test_45page_45fec2EBFa7W3u3vMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/test-page-fec2.vue").then(m => m.default || m)
  },
  {
    name: topicfjgxvUGkM4Meta?.name ?? "topic",
    path: topicfjgxvUGkM4Meta?.path ?? "/topic",
    children: [
  {
    name: _91slug_934vzq28VdIzMeta?.name ?? "topic-slug",
    path: _91slug_934vzq28VdIzMeta?.path ?? ":slug()",
    meta: _91slug_934vzq28VdIzMeta || {},
    alias: _91slug_934vzq28VdIzMeta?.alias || [],
    redirect: _91slug_934vzq28VdIzMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/topic/[slug].vue").then(m => m.default || m)
  }
],
    meta: topicfjgxvUGkM4Meta || {},
    alias: topicfjgxvUGkM4Meta?.alias || [],
    redirect: topicfjgxvUGkM4Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/topic.vue").then(m => m.default || m)
  },
  {
    name: whatsapp_45create_45cartPgOFtB9JknMeta?.name ?? "whatsapp-create-cart",
    path: whatsapp_45create_45cartPgOFtB9JknMeta?.path ?? "/whatsapp-create-cart",
    meta: whatsapp_45create_45cartPgOFtB9JknMeta || {},
    alias: whatsapp_45create_45cartPgOFtB9JknMeta?.alias || [],
    redirect: whatsapp_45create_45cartPgOFtB9JknMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/whatsapp-create-cart.vue").then(m => m.default || m)
  },
  {
    name: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.name ?? "whatsapp-privacy-policy",
    path: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.path ?? "/whatsapp-privacy-policy",
    meta: whatsapp_45privacy_45policy93Zui3Q4rcMeta || {},
    alias: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.alias || [],
    redirect: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/whatsapp-privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: partner_45shopxXLFlAm8oIMeta?.name ?? "widgets-en-partner-shop",
    path: partner_45shopxXLFlAm8oIMeta?.path ?? "/widgets-en/partner-shop",
    meta: partner_45shopxXLFlAm8oIMeta || {},
    alias: partner_45shopxXLFlAm8oIMeta?.alias || [],
    redirect: partner_45shopxXLFlAm8oIMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/widgets-en/partner-shop.vue").then(m => m.default || m)
  },
  {
    name: register_45enwkCm91By9GMeta?.name ?? "register",
    path: register_45enwkCm91By9GMeta?.path ?? "/register",
    meta: {...(register_45enwkCm91By9GMeta || {}), ...{"lang":"de"}},
    alias: register_45enwkCm91By9GMeta?.alias || [],
    redirect: register_45enwkCm91By9GMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register-en.vue").then(m => m.default || m)
  },
  {
    name: _91token_934gxUM9QUqCMeta?.name ?? "register-confirm",
    path: _91token_934gxUM9QUqCMeta?.path ?? "/register/confirm/:token",
    meta: {...(_91token_934gxUM9QUqCMeta || {}), ...{"lang":"de"}},
    alias: _91token_934gxUM9QUqCMeta?.alias || [],
    redirect: _91token_934gxUM9QUqCMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-en/[token].vue").then(m => m.default || m)
  },
  {
    name: _91pharmacyId_93c3fMDKG0zVMeta?.name ?? "data-sharing-confirmation",
    path: _91pharmacyId_93c3fMDKG0zVMeta?.path ?? "/register/confirm-crm-link-existing/{customerNumber}/{pharmacyId}",
    meta: {...(_91pharmacyId_93c3fMDKG0zVMeta || {}), ...{"lang":"de"}},
    alias: _91pharmacyId_93c3fMDKG0zVMeta?.alias || [],
    redirect: _91pharmacyId_93c3fMDKG0zVMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-crm-link-existing/[customerNumber]/[pharmacyId].vue").then(m => m.default || m)
  },
  {
    name: _91token_93dhxKPNZxuRMeta?.name ?? "register-confirm-crm",
    path: _91token_93dhxKPNZxuRMeta?.path ?? "/register/confirm-crm/:token",
    meta: {...(_91token_93dhxKPNZxuRMeta || {}), ...{"lang":"de"}},
    alias: _91token_93dhxKPNZxuRMeta?.alias || [],
    redirect: _91token_93dhxKPNZxuRMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/register/confirm-crm-en/[token].vue").then(m => m.default || m)
  },
  {
    name: login_45enbtG3bhYamKMeta?.name ?? "login",
    path: login_45enbtG3bhYamKMeta?.path ?? "/login",
    meta: {...(login_45enbtG3bhYamKMeta || {}), ...{"lang":"de"}},
    alias: login_45enbtG3bhYamKMeta?.alias || [],
    redirect: login_45enbtG3bhYamKMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/login-en.vue").then(m => m.default || m)
  },
  {
    name: logoutdh5kyPF7fPMeta?.name ?? "logout",
    path: logoutdh5kyPF7fPMeta?.path ?? "/logout",
    meta: {...(logoutdh5kyPF7fPMeta || {}), ...{"lang":"de"}},
    alias: logoutdh5kyPF7fPMeta?.alias || [],
    redirect: logoutdh5kyPF7fPMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: optoutGRFYP5fYIuMeta?.name ?? "account-optout",
    path: optoutGRFYP5fYIuMeta?.path ?? "/account/optout",
    meta: {...(optoutGRFYP5fYIuMeta || {}), ...{"lang":"de"}},
    alias: optoutGRFYP5fYIuMeta?.alias || [],
    redirect: optoutGRFYP5fYIuMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/optout.vue").then(m => m.default || m)
  },
  {
    name: requestIYKz0yNNd4Meta?.name ?? "resetting-request",
    path: requestIYKz0yNNd4Meta?.path ?? "/resetting/request",
    meta: {...(requestIYKz0yNNd4Meta || {}), ...{"lang":"de"}},
    alias: requestIYKz0yNNd4Meta?.alias || [],
    redirect: requestIYKz0yNNd4Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/resetting/request.vue").then(m => m.default || m)
  },
  {
    name: _91token_93bnBPol3kk5Meta?.name ?? "resetting-reset",
    path: _91token_93bnBPol3kk5Meta?.path ?? "/resetting/reset",
    meta: {...(_91token_93bnBPol3kk5Meta || {}), ...{"lang":"de"}},
    alias: _91token_93bnBPol3kk5Meta?.alias || [],
    redirect: _91token_93bnBPol3kk5Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/resetting/reset/[token].vue").then(m => m.default || m)
  },
  {
    name: careerBepgV5ZqwSMeta?.name ?? "karriere",
    path: careerBepgV5ZqwSMeta?.path ?? "/karriere",
    meta: {...(careerBepgV5ZqwSMeta || {}), ...{"lang":"de"}},
    alias: careerBepgV5ZqwSMeta?.alias || [],
    redirect: careerBepgV5ZqwSMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/career.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45useLVN2v29mupMeta?.name ?? "nutzungsbedingungen",
    path: terms_45of_45useLVN2v29mupMeta?.path ?? "/nutzungsbedingungen",
    meta: {...(terms_45of_45useLVN2v29mupMeta || {}), ...{"lang":"de"}},
    alias: terms_45of_45useLVN2v29mupMeta?.alias || [],
    redirect: terms_45of_45useLVN2v29mupMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/terms-of-use.vue").then(m => m.default || m)
  },
  {
    name: corona_45enBTZg8dX5SLMeta?.name ?? "corona",
    path: corona_45enBTZg8dX5SLMeta?.path ?? "/corona",
    meta: {...(corona_45enBTZg8dX5SLMeta || {}), ...{"lang":"de"}},
    alias: corona_45enBTZg8dX5SLMeta?.alias || [],
    redirect: corona_45enBTZg8dX5SLMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/corona-en.vue").then(m => m.default || m)
  },
  {
    name: about_45ustEOi6mjb3fMeta?.name ?? "ueber-uns",
    path: about_45ustEOi6mjb3fMeta?.path ?? "/ueber-uns",
    meta: {...(about_45ustEOi6mjb3fMeta || {}), ...{"lang":"de"}},
    alias: about_45ustEOi6mjb3fMeta?.alias || [],
    redirect: about_45ustEOi6mjb3fMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: searchzTV48k1fLwMeta?.name ?? "suche",
    path: searchzTV48k1fLwMeta?.path ?? "/suche",
    meta: {...(searchzTV48k1fLwMeta || {}), ...{"lang":"de"}},
    alias: searchzTV48k1fLwMeta?.alias || [],
    redirect: searchzTV48k1fLwMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/search.vue").then(m => m.default || m)
  },
  {
    name: imprintLZGiH4R1Z8Meta?.name ?? "impressum",
    path: imprintLZGiH4R1Z8Meta?.path ?? "/impressum",
    meta: {...(imprintLZGiH4R1Z8Meta || {}), ...{"lang":"de"}},
    alias: imprintLZGiH4R1Z8Meta?.alias || [],
    redirect: imprintLZGiH4R1Z8Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/imprint.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyFLzoNrKVOwMeta?.name ?? "datenschutz",
    path: privacy_45policyFLzoNrKVOwMeta?.path ?? "/datenschutz",
    meta: {...(privacy_45policyFLzoNrKVOwMeta || {}), ...{"lang":"de"}},
    alias: privacy_45policyFLzoNrKVOwMeta?.alias || [],
    redirect: privacy_45policyFLzoNrKVOwMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.name ?? "whatsapp-datenschutz",
    path: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.path ?? "/privacy/:pharmacyId(\\d+)/datenschutz-externe-messengerdienste",
    meta: {...(whatsapp_45privacy_45policy93Zui3Q4rcMeta || {}), ...{"lang":"de"}},
    alias: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.alias || [],
    redirect: whatsapp_45privacy_45policy93Zui3Q4rcMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/whatsapp-privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: contactDm1VwxJ2DTMeta?.name ?? "kontakt",
    path: contactDm1VwxJ2DTMeta?.path ?? "/kontakt",
    meta: {...(contactDm1VwxJ2DTMeta || {}), ...{"lang":"de"}},
    alias: contactDm1VwxJ2DTMeta?.alias || [],
    redirect: contactDm1VwxJ2DTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contact_45pharmacyGY5AVXdupeMeta?.name ?? "apotheke-pharmacyId-short-apotheke-kontakt",
    path: contact_45pharmacyGY5AVXdupeMeta?.path ?? "/apotheke/:pharmacyId(\\d+)/apotheke-kontakt",
    meta: {...(contact_45pharmacyGY5AVXdupeMeta || {}), ...{"lang":"de"}},
    alias: contact_45pharmacyGY5AVXdupeMeta?.alias || [],
    redirect: contact_45pharmacyGY5AVXdupeMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/contact-pharmacy.vue").then(m => m.default || m)
  },
  {
    name: faq_45env56tio3QgfMeta?.name ?? "faq",
    path: faq_45env56tio3QgfMeta?.path ?? "/faq",
    meta: {...(faq_45env56tio3QgfMeta || {}), ...{"lang":"de"}},
    alias: faq_45env56tio3QgfMeta?.alias || [],
    redirect: faq_45env56tio3QgfMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/faq-en.vue").then(m => m.default || m)
  },
  {
    name: newsletter_45enQNHCSyAwUUMeta?.name ?? "newsletter",
    path: newsletter_45enQNHCSyAwUUMeta?.path ?? "/newsletter",
    meta: {...(newsletter_45enQNHCSyAwUUMeta || {}), ...{"lang":"de"}},
    alias: newsletter_45enQNHCSyAwUUMeta?.alias || [],
    redirect: newsletter_45enQNHCSyAwUUMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/newsletter-en.vue").then(m => m.default || m)
  },
  {
    name: express_45deliveryNgA0XN1uSVMeta?.name ?? "express-botendienst",
    path: express_45deliveryNgA0XN1uSVMeta?.path ?? "/express-botendienst",
    meta: {...(express_45deliveryNgA0XN1uSVMeta || {}), ...{"lang":"de"}},
    alias: express_45deliveryNgA0XN1uSVMeta?.alias || [],
    redirect: express_45deliveryNgA0XN1uSVMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/express-delivery.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.name ?? "apotheke-pharmacyName-pharmacyPlz-pharmacyId",
    path: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.path ?? "/apotheke/:pharmacyName(.*)*-:pharmacyPlz(\\d+)-:pharmacyId(\\d+)",
    meta: {...(_91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta || {}), ...{"lang":"de"}},
    alias: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.alias || [],
    redirect: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[...pharmacyName]-[pharmacyPlz]-[pharmacyId].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.name ?? "apotheke-pharmacyId-short",
    path: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.path ?? "/apotheke/:pharmacyId(\\d+)",
    meta: {...(_91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta || {}), ...{"lang":"de"}},
    alias: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.alias || [],
    redirect: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[...pharmacyName]-[pharmacyPlz]-[pharmacyId].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.name ?? "pharmacy-pharmacyId-short",
    path: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.path ?? "/pharmacy/:pharmacyId(\\d+)",
    meta: {...(_91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta || {}), ...{"lang":"de"}},
    alias: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.alias || [],
    redirect: _91_46_46_46pharmacyName_93_45_91pharmacyPlz_93_45_91pharmacyId_93A9CtdeqddTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[...pharmacyName]-[pharmacyPlz]-[pharmacyId].vue").then(m => m.default || m)
  },
  {
    name: prescription_45uploadBQAUDYMK7hMeta?.name ?? "rezept-upload",
    path: prescription_45uploadBQAUDYMK7hMeta?.path ?? "/rezept-upload",
    meta: {...(prescription_45uploadBQAUDYMK7hMeta || {}), ...{"lang":"de"}},
    alias: prescription_45uploadBQAUDYMK7hMeta?.alias || [],
    redirect: prescription_45uploadBQAUDYMK7hMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/prescription-upload.vue").then(m => m.default || m)
  },
  {
    name: prescription_45uploadrtneugFh8LMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-rezept-upload",
    path: prescription_45uploadrtneugFh8LMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz(\\d+)-:pharmacyId(\\d+)/rezept-upload",
    meta: {...(prescription_45uploadrtneugFh8LMeta || {}), ...{"lang":"de"}},
    alias: prescription_45uploadrtneugFh8LMeta?.alias || [],
    redirect: prescription_45uploadrtneugFh8LMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/prescription-upload.vue").then(m => m.default || m)
  },
  {
    name: prescription_45uploadrtneugFh8LMeta?.name ?? "pharmacyId-rezept-upload",
    path: prescription_45uploadrtneugFh8LMeta?.path ?? "/:pharmacyId(\\d+)/rezept-upload",
    meta: {...(prescription_45uploadrtneugFh8LMeta || {}), ...{"lang":"de"}},
    alias: prescription_45uploadrtneugFh8LMeta?.alias || [],
    redirect: prescription_45uploadrtneugFh8LMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/prescription-upload.vue").then(m => m.default || m)
  },
  {
    name: prescription_45uploadrtneugFh8LMeta?.name ?? "pharmacyId-prescription-upload",
    path: prescription_45uploadrtneugFh8LMeta?.path ?? "/:pharmacyId(\\d+)/prescription-upload",
    meta: {...(prescription_45uploadrtneugFh8LMeta || {}), ...{"lang":"en"}},
    alias: prescription_45uploadrtneugFh8LMeta?.alias || [],
    redirect: prescription_45uploadrtneugFh8LMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/prescription-upload.vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93HA2hzLuHsPMeta?.name ?? "produkt-productName-pzn",
    path: _91pzn_93HA2hzLuHsPMeta?.path ?? "/produkt/:productName/:pzn(\\d+)",
    meta: {...(_91pzn_93HA2hzLuHsPMeta || {}), ...{"lang":"de"}},
    alias: _91pzn_93HA2hzLuHsPMeta?.alias || [],
    redirect: _91pzn_93HA2hzLuHsPMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/product/[productName]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93cTMpUw3sIQMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-produkt-productName-pzn",
    path: _91pzn_93cTMpUw3sIQMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz(\\d+)-:pharmacyId(\\d+)/produkt/:productName/:pzn(\\d+)",
    meta: {...(_91pzn_93cTMpUw3sIQMeta || {}), ...{"lang":"de"}},
    alias: _91pzn_93cTMpUw3sIQMeta?.alias || [],
    redirect: _91pzn_93cTMpUw3sIQMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/product/[productName]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93cTMpUw3sIQMeta?.name ?? "pharmacyId-produkt-productName-pzn",
    path: _91pzn_93cTMpUw3sIQMeta?.path ?? "/:pharmacyId(\\d+)/produkt/:productName/:pzn(\\d+)",
    meta: {...(_91pzn_93cTMpUw3sIQMeta || {}), ...{"lang":"de"}},
    alias: _91pzn_93cTMpUw3sIQMeta?.alias || [],
    redirect: _91pzn_93cTMpUw3sIQMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/product/[productName]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93cTMpUw3sIQMeta?.name ?? "pharmacyId-product-productName-pzn",
    path: _91pzn_93cTMpUw3sIQMeta?.path ?? "/:pharmacyId(\\d+)/product/:productName/:pzn(\\d+)",
    meta: {...(_91pzn_93cTMpUw3sIQMeta || {}), ...{"lang":"en"}},
    alias: _91pzn_93cTMpUw3sIQMeta?.alias || [],
    redirect: _91pzn_93cTMpUw3sIQMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/product/[productName]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: productslXxUFvAZCpMeta?.name ?? "produkte",
    path: productslXxUFvAZCpMeta?.path ?? "/produkte",
    meta: {...(productslXxUFvAZCpMeta || {}), ...{"lang":"de"}},
    alias: productslXxUFvAZCpMeta?.alias || [],
    redirect: productslXxUFvAZCpMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/products.vue").then(m => m.default || m)
  },
  {
    name: productstKWOGzKLldMeta?.name ?? "pharmacyName-pharmacyPlz-pharmacyId-produkte",
    path: productstKWOGzKLldMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz(\\d+)-:pharmacyId(\\d+)/produkte",
    meta: {...(productstKWOGzKLldMeta || {}), ...{"lang":"de"}},
    alias: productstKWOGzKLldMeta?.alias || [],
    redirect: productstKWOGzKLldMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/products.vue").then(m => m.default || m)
  },
  {
    name: productstKWOGzKLldMeta?.name ?? "pharmacyId-produkte",
    path: productstKWOGzKLldMeta?.path ?? "/:pharmacyId(\\d+)/produkte",
    meta: {...(productstKWOGzKLldMeta || {}), ...{"lang":"de"}},
    alias: productstKWOGzKLldMeta?.alias || [],
    redirect: productstKWOGzKLldMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/products.vue").then(m => m.default || m)
  },
  {
    name: productstKWOGzKLldMeta?.name ?? "pharmacyId-products",
    path: productstKWOGzKLldMeta?.path ?? "/:pharmacyId(\\d+)/products",
    meta: {...(productstKWOGzKLldMeta || {}), ...{"lang":"de"}},
    alias: productstKWOGzKLldMeta?.alias || [],
    redirect: productstKWOGzKLldMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/products.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93wlMddoA6QVMeta?.name ?? "manufacturer",
    path: _91slug_93wlMddoA6QVMeta?.path ?? "/produkte/hersteller/:slug",
    meta: {...(_91slug_93wlMddoA6QVMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93wlMddoA6QVMeta?.alias || [],
    redirect: _91slug_93wlMddoA6QVMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/manufacturers/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93uy34DkD4nHMeta?.name ?? "pharmacyId-category",
    path: _91slug_93uy34DkD4nHMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz(\\d+)-:pharmacyId(\\d+)/produkte/kategorie/:slug",
    meta: {...(_91slug_93uy34DkD4nHMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93uy34DkD4nHMeta?.alias || [],
    redirect: _91slug_93uy34DkD4nHMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/categories/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93uy34DkD4nHMeta?.name ?? "pharmacyId-category-short",
    path: _91slug_93uy34DkD4nHMeta?.path ?? "/:pharmacyId(\\d+)/produkte/kategorie/:slug",
    meta: {...(_91slug_93uy34DkD4nHMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93uy34DkD4nHMeta?.alias || [],
    redirect: _91slug_93uy34DkD4nHMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/categories/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ItWRAx3quTMeta?.name ?? "pharmacyId-manufacturer",
    path: _91slug_93ItWRAx3quTMeta?.path ?? "/:pharmacyName(.*)*-:pharmacyPlz(\\d+)-:pharmacyId(\\d+)/produkte/hersteller/:slug",
    meta: {...(_91slug_93ItWRAx3quTMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93ItWRAx3quTMeta?.alias || [],
    redirect: _91slug_93ItWRAx3quTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/manufacturers/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ItWRAx3quTMeta?.name ?? "pharmacyId-manufacturer-short",
    path: _91slug_93ItWRAx3quTMeta?.path ?? "/:pharmacyId(\\d+)/produkte/hersteller/:slug",
    meta: {...(_91slug_93ItWRAx3quTMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93ItWRAx3quTMeta?.alias || [],
    redirect: _91slug_93ItWRAx3quTMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/[...pharmacyName]-[pharmacyPlz]-[pharmacyId]/manufacturers/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93uQlFmsei7FMeta?.name ?? "category",
    path: _91slug_93uQlFmsei7FMeta?.path ?? "/produkte/kategorie/:slug",
    meta: {...(_91slug_93uQlFmsei7FMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93uQlFmsei7FMeta?.alias || [],
    redirect: _91slug_93uQlFmsei7FMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/category/[slug].vue").then(m => m.default || m)
  },
  {
    name: express_45deliverytYPUSvkDoeMeta?.name ?? "apotheke-pharmacyId-express-botendienst",
    path: express_45deliverytYPUSvkDoeMeta?.path ?? "/apotheke/:pharmacyId(\\d+)/express-botendienst",
    meta: {...(express_45deliverytYPUSvkDoeMeta || {}), ...{"lang":"de"}},
    alias: express_45deliverytYPUSvkDoeMeta?.alias || [],
    redirect: express_45deliverytYPUSvkDoeMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/express-delivery.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93SextJPAErRMeta?.name ?? "apotheke-pharmacyId-themenuebersicht-slug",
    path: _91slug_93SextJPAErRMeta?.path ?? "/apotheke/:pharmacyId(\\d+)/themenuebersicht/:slug",
    meta: {...(_91slug_93SextJPAErRMeta || {}), ...{"lang":"de","redirectPharmacy":["/rezept-upload"]}},
    alias: _91slug_93SextJPAErRMeta?.alias || [],
    redirect: _91slug_93SextJPAErRMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/topic/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93bvMtV2K17cMeta?.name ?? "apotheke-pharmacyId-markenuebersicht-slug",
    path: _91slug_93bvMtV2K17cMeta?.path ?? "/apotheke/:pharmacyId(\\d+)/markenuebersicht/:slug",
    meta: {...(_91slug_93bvMtV2K17cMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93bvMtV2K17cMeta?.alias || [],
    redirect: _91slug_93bvMtV2K17cMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy/[pharmacyId]/brand/[slug].vue").then(m => m.default || m)
  },
  {
    name: pharmacy_45finderq6kkAuAdQUMeta?.name ?? "apofinder",
    path: pharmacy_45finderq6kkAuAdQUMeta?.path ?? "/apofinder",
    meta: {...(pharmacy_45finderq6kkAuAdQUMeta || {}), ...{"lang":"de"}},
    alias: pharmacy_45finderq6kkAuAdQUMeta?.alias || [],
    redirect: pharmacy_45finderq6kkAuAdQUMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/pharmacy-finder.vue").then(m => m.default || m)
  },
  {
    name: find_45pharmacyTu75v5hs2RMeta?.name ?? "apotheke-finden",
    path: find_45pharmacyTu75v5hs2RMeta?.path ?? "/apotheke-finden",
    meta: {...(find_45pharmacyTu75v5hs2RMeta || {}), ...{"lang":"de"}},
    alias: find_45pharmacyTu75v5hs2RMeta?.alias || [],
    redirect: find_45pharmacyTu75v5hs2RMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/find-pharmacy.vue").then(m => m.default || m)
  },
  {
    name: branddYvynfl1utMeta?.name ?? "markenuebersicht",
    path: branddYvynfl1utMeta?.path ?? "/markenuebersicht",
    children: [
  {
    name: _91slug_93PrLtC4epOjMeta?.name ?? "markenuebersicht-slug",
    path: _91slug_93PrLtC4epOjMeta?.path ?? ":slug",
    meta: {...(_91slug_93PrLtC4epOjMeta || {}), ...{"lang":"de"}},
    alias: _91slug_93PrLtC4epOjMeta?.alias || [],
    redirect: _91slug_93PrLtC4epOjMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/brand/[slug].vue").then(m => m.default || m)
  }
],
    meta: branddYvynfl1utMeta || {},
    alias: branddYvynfl1utMeta?.alias || [],
    redirect: branddYvynfl1utMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/brand.vue").then(m => m.default || m)
  },
  {
    name: topicfjgxvUGkM4Meta?.name ?? "themenuebersicht",
    path: topicfjgxvUGkM4Meta?.path ?? "/themenuebersicht",
    meta: {...(topicfjgxvUGkM4Meta || {}), ...{"lang":"de"}},
    alias: topicfjgxvUGkM4Meta?.alias || [],
    redirect: topicfjgxvUGkM4Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/topic.vue").then(m => m.default || m)
  },
  {
    name: _91slug_934vzq28VdIzMeta?.name ?? "themenuebersicht-slug",
    path: _91slug_934vzq28VdIzMeta?.path ?? "/themenuebersicht/:slug",
    meta: {...(_91slug_934vzq28VdIzMeta || {}), ...{"lang":"de"}},
    alias: _91slug_934vzq28VdIzMeta?.alias || [],
    redirect: _91slug_934vzq28VdIzMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/topic/[slug].vue").then(m => m.default || m)
  },
  {
    name: newYhQ8d3MgWUMeta?.name ?? "kundenkonto-userId-rechnungsadresse-neu",
    path: newYhQ8d3MgWUMeta?.path ?? "/kundenkonto/:userId/rechnungsadresse/neu",
    meta: {...(newYhQ8d3MgWUMeta || {}), ...{"lang":"de"}},
    alias: newYhQ8d3MgWUMeta?.alias || [],
    redirect: newYhQ8d3MgWUMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/billing-address/new.vue").then(m => m.default || m)
  },
  {
    name: _91addressId_935HWvIBmpv2Meta?.name ?? "kundenkonto-userId-rechnungsadresse-addressId",
    path: _91addressId_935HWvIBmpv2Meta?.path ?? "/kundenkonto/:userId/rechnungsadresse/:addressId",
    meta: {...(_91addressId_935HWvIBmpv2Meta || {}), ...{"lang":"de"}},
    alias: _91addressId_935HWvIBmpv2Meta?.alias || [],
    redirect: _91addressId_935HWvIBmpv2Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/billing-address/[addressId].vue").then(m => m.default || m)
  },
  {
    name: change_45passwordRx2ovwOZnLMeta?.name ?? "kundenkonto-userId-passwort-andern",
    path: change_45passwordRx2ovwOZnLMeta?.path ?? "/kundenkonto/:userId/passwort-andern",
    meta: {...(change_45passwordRx2ovwOZnLMeta || {}), ...{"lang":"de"}},
    alias: change_45passwordRx2ovwOZnLMeta?.alias || [],
    redirect: change_45passwordRx2ovwOZnLMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-password.vue").then(m => m.default || m)
  },
  {
    name: editPlloOpFWKkMeta?.name ?? "kundenkonto-userId-bearbeiten",
    path: editPlloOpFWKkMeta?.path ?? "/kundenkonto/:userId/bearbeiten",
    meta: {...(editPlloOpFWKkMeta || {}), ...{"lang":"de"}},
    alias: editPlloOpFWKkMeta?.alias || [],
    redirect: editPlloOpFWKkMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/edit.vue").then(m => m.default || m)
  },
  {
    name: ordersRmm8Xn7ZriMeta?.name ?? "kundenkonto-userId-bestellungen",
    path: ordersRmm8Xn7ZriMeta?.path ?? "/kundenkonto/:userId/bestellungen",
    meta: {...(ordersRmm8Xn7ZriMeta || {}), ...{"lang":"de"}},
    alias: ordersRmm8Xn7ZriMeta?.alias || [],
    redirect: ordersRmm8Xn7ZriMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/orders.vue").then(m => m.default || m)
  },
  {
    name: indexQm0ZZPPwJqMeta?.name ?? "kundenkonto-userId-erneut-bestellen-orderId",
    path: indexQm0ZZPPwJqMeta?.path ?? "/kundenkonto/:userId/erneut-bestellen/:orderId",
    meta: {...(indexQm0ZZPPwJqMeta || {}), ...{"lang":"de"}},
    alias: indexQm0ZZPPwJqMeta?.alias || [],
    redirect: indexQm0ZZPPwJqMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/reorder/[orderId]/index.vue").then(m => m.default || m)
  },
  {
    name: _91pzn_93cUsvGLvPqHMeta?.name ?? "kundenkonto-userId-erneut-bestellen-orderId-pzn",
    path: _91pzn_93cUsvGLvPqHMeta?.path ?? "/kundenkonto/:userId/erneut-bestellen/:orderId/:pzn",
    meta: {...(_91pzn_93cUsvGLvPqHMeta || {}), ...{"lang":"de"}},
    alias: _91pzn_93cUsvGLvPqHMeta?.alias || [],
    redirect: _91pzn_93cUsvGLvPqHMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/reorder/[orderId]/[pzn].vue").then(m => m.default || m)
  },
  {
    name: _91addressId_93XIi89ydefkMeta?.name ?? "kundenkonto-userId-lieferaddresse-addressId",
    path: _91addressId_93XIi89ydefkMeta?.path ?? "/kundenkonto/:userId/lieferaddresse/:addressId",
    meta: {...(_91addressId_93XIi89ydefkMeta || {}), ...{"lang":"de"}},
    alias: _91addressId_93XIi89ydefkMeta?.alias || [],
    redirect: _91addressId_93XIi89ydefkMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/delivery-address/[addressId].vue").then(m => m.default || m)
  },
  {
    name: newrGL1AhQLQsMeta?.name ?? "kundenkonto-userId-lieferaddresse-neu",
    path: newrGL1AhQLQsMeta?.path ?? "/kundenkonto/:userId/lieferaddresse/neu",
    meta: {...(newrGL1AhQLQsMeta || {}), ...{"lang":"de"}},
    alias: newrGL1AhQLQsMeta?.alias || [],
    redirect: newrGL1AhQLQsMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/delivery-address/new.vue").then(m => m.default || m)
  },
  {
    name: _91token_931CZhhlZEgNMeta?.name ?? "kundenkonto-userId-email-andern-bestaetigung-nicht-verifiziert-id-secretKey-token",
    path: _91token_931CZhhlZEgNMeta?.path ?? "/kundenkonto/:userId/email-andern/bestaetigung/nicht-verifiziert/:id/:secretKey/:token",
    meta: {...(_91token_931CZhhlZEgNMeta || {}), ...{"lang":"de"}},
    alias: _91token_931CZhhlZEgNMeta?.alias || [],
    redirect: _91token_931CZhhlZEgNMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/confirmation/not-verified/[id]/[secretKey]/[token].vue").then(m => m.default || m)
  },
  {
    name: _91secretKey_93l2vDVndJ1mMeta?.name ?? "kundenkonto-userId-email-andern-bestaetigung-verifiziert-id-secretKey",
    path: _91secretKey_93l2vDVndJ1mMeta?.path ?? "/kundenkonto/:userId/email-andern/bestaetigung/verifiziert/:id/:secretKey",
    meta: {...(_91secretKey_93l2vDVndJ1mMeta || {}), ...{"lang":"de"}},
    alias: _91secretKey_93l2vDVndJ1mMeta?.alias || [],
    redirect: _91secretKey_93l2vDVndJ1mMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/confirmation/verified/[id]/[secretKey].vue").then(m => m.default || m)
  },
  {
    name: requestm9Dd36CJsoMeta?.name ?? "kundenkonto-userId-email-andern-anfrage",
    path: requestm9Dd36CJsoMeta?.path ?? "/kundenkonto/:userId/email-andern/anfrage",
    meta: {...(requestm9Dd36CJsoMeta || {}), ...{"lang":"de"}},
    alias: requestm9Dd36CJsoMeta?.alias || [],
    redirect: requestm9Dd36CJsoMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/request.vue").then(m => m.default || m)
  },
  {
    name: sucessaJ9pXZoAcjMeta?.name ?? "kundenkonto-userId-email-andern-erfolg",
    path: sucessaJ9pXZoAcjMeta?.path ?? "/kundenkonto/:userId/email-andern/erfolg",
    meta: {...(sucessaJ9pXZoAcjMeta || {}), ...{"lang":"de"}},
    alias: sucessaJ9pXZoAcjMeta?.alias || [],
    redirect: sucessaJ9pXZoAcjMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email/sucess.vue").then(m => m.default || m)
  },
  {
    name: change_45emailweQhoLbegiMeta?.name ?? "kundenkonto-userId-email-andern",
    path: change_45emailweQhoLbegiMeta?.path ?? "/kundenkonto/:userId/email-andern",
    meta: {...(change_45emailweQhoLbegiMeta || {}), ...{"lang":"de"}},
    alias: change_45emailweQhoLbegiMeta?.alias || [],
    redirect: change_45emailweQhoLbegiMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/change-email.vue").then(m => m.default || m)
  },
  {
    name: data_45sharingCpwyjYjIAfMeta?.name ?? "kundenkonto-userId-datenfreigabe",
    path: data_45sharingCpwyjYjIAfMeta?.path ?? "/kundenkonto/:userId/datenfreigabe",
    meta: {...(data_45sharingCpwyjYjIAfMeta || {}), ...{"lang":"de"}},
    alias: data_45sharingCpwyjYjIAfMeta?.alias || [],
    redirect: data_45sharingCpwyjYjIAfMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId]/data-sharing.vue").then(m => m.default || m)
  },
  {
    name: _91userId_93szeyQbiYuXMeta?.name ?? "kundenkonto-userId",
    path: _91userId_93szeyQbiYuXMeta?.path ?? "/kundenkonto/:userId",
    meta: {...(_91userId_93szeyQbiYuXMeta || {}), ...{"lang":"de"}},
    alias: _91userId_93szeyQbiYuXMeta?.alias || [],
    redirect: _91userId_93szeyQbiYuXMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/account/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93VcS9ajAkJsMeta?.name ?? "warenkorb-danke-draftId",
    path: _91draftId_93VcS9ajAkJsMeta?.path ?? "/warenkorb/danke/:draftId",
    meta: _91draftId_93VcS9ajAkJsMeta || {},
    alias: _91draftId_93VcS9ajAkJsMeta?.alias || [],
    redirect: _91draftId_93VcS9ajAkJsMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/confirmation/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93AKIPzmDSABMeta?.name ?? "warenkorb-kundendaten-draftId",
    path: _91draftId_93AKIPzmDSABMeta?.path ?? "/warenkorb/kundendaten/:draftId",
    meta: _91draftId_93AKIPzmDSABMeta || {},
    alias: _91draftId_93AKIPzmDSABMeta?.alias || [],
    redirect: _91draftId_93AKIPzmDSABMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/customer/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93iyxaIIweF7Meta?.name ?? "warenkorb-lieferart-draftId",
    path: _91draftId_93iyxaIIweF7Meta?.path ?? "/warenkorb/lieferart/:draftId",
    meta: _91draftId_93iyxaIIweF7Meta || {},
    alias: _91draftId_93iyxaIIweF7Meta?.alias || [],
    redirect: _91draftId_93iyxaIIweF7Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/delivery/[draftId].vue").then(m => m.default || m)
  },
  {
    name: indexF7F2YClA6cMeta?.name ?? "warenkorb-einzelheiten",
    path: indexF7F2YClA6cMeta?.path ?? "/warenkorb/einzelheiten",
    meta: indexF7F2YClA6cMeta || {},
    alias: indexF7F2YClA6cMeta?.alias || [],
    redirect: indexF7F2YClA6cMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91draftId_933N8XMi3R4wMeta?.name ?? "warenkorb-einzelheiten-draftId",
    path: _91draftId_933N8XMi3R4wMeta?.path ?? "/warenkorb/einzelheiten/:draftId",
    meta: _91draftId_933N8XMi3R4wMeta || {},
    alias: _91draftId_933N8XMi3R4wMeta?.alias || [],
    redirect: _91draftId_933N8XMi3R4wMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/cart/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_936UTozYDiahMeta?.name ?? "warenkorb-uberprufen-draftId",
    path: _91draftId_936UTozYDiahMeta?.path ?? "/warenkorb/uberprufen/:draftId",
    meta: _91draftId_936UTozYDiahMeta || {},
    alias: _91draftId_936UTozYDiahMeta?.alias || [],
    redirect: _91draftId_936UTozYDiahMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/overview/[draftId].vue").then(m => m.default || m)
  },
  {
    name: _91draftId_93jHsEaYKPDeMeta?.name ?? "warenkorb-zahlungsart-draftId",
    path: _91draftId_93jHsEaYKPDeMeta?.path ?? "/warenkorb/zahlungsart/:draftId",
    meta: _91draftId_93jHsEaYKPDeMeta || {},
    alias: _91draftId_93jHsEaYKPDeMeta?.alias || [],
    redirect: _91draftId_93jHsEaYKPDeMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/checkout/payment/[draftId].vue").then(m => m.default || m)
  },
  {
    name: partner_45shopxXLFlAm8oIMeta?.name ?? "widgets-partnershop",
    path: partner_45shopxXLFlAm8oIMeta?.path ?? "/widgets/partnershop",
    meta: {...(partner_45shopxXLFlAm8oIMeta || {}), ...{"lang":"de"}},
    alias: partner_45shopxXLFlAm8oIMeta?.alias || [],
    redirect: partner_45shopxXLFlAm8oIMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/widgets-en/partner-shop.vue").then(m => m.default || m)
  },
  {
    name: index2AhX13BOA3Meta?.name ?? "epaper",
    path: index2AhX13BOA3Meta?.path ?? "/epaper",
    meta: {...(index2AhX13BOA3Meta || {}), ...{"lang":"de"}},
    alias: index2AhX13BOA3Meta?.alias || [],
    redirect: index2AhX13BOA3Meta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/index.vue").then(m => m.default || m)
  },
  {
    name: magazineM0CxO4FrnMMeta?.name ?? "epaper-magazine",
    path: magazineM0CxO4FrnMMeta?.path ?? "/epaper/magazine",
    meta: {...(magazineM0CxO4FrnMMeta || {}), ...{"lang":"de"}},
    alias: magazineM0CxO4FrnMMeta?.alias || [],
    redirect: magazineM0CxO4FrnMMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/magazine.vue").then(m => m.default || m)
  },
  {
    name: indexFPldh7IYOIMeta?.name ?? "epaper-abonnieren",
    path: indexFPldh7IYOIMeta?.path ?? "/epaper/abonnieren",
    meta: {...(indexFPldh7IYOIMeta || {}), ...{"lang":"de"}},
    alias: indexFPldh7IYOIMeta?.alias || [],
    redirect: indexFPldh7IYOIMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/subscribe/index.vue").then(m => m.default || m)
  },
  {
    name: successzOgEIc6ZJEMeta?.name ?? "epaper-abonnieren-bestaetigt",
    path: successzOgEIc6ZJEMeta?.path ?? "/epaper/abonnieren-bestaetigt",
    meta: {...(successzOgEIc6ZJEMeta || {}), ...{"lang":"de"}},
    alias: successzOgEIc6ZJEMeta?.alias || [],
    redirect: successzOgEIc6ZJEMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/subscribe/success.vue").then(m => m.default || m)
  },
  {
    name: indexHrYGoMP0SdMeta?.name ?? "epaper-abbestellen-bestaetigt",
    path: indexHrYGoMP0SdMeta?.path ?? "/epaper/abbestellen-bestaetigt",
    meta: {...(indexHrYGoMP0SdMeta || {}), ...{"lang":"de"}},
    alias: indexHrYGoMP0SdMeta?.alias || [],
    redirect: indexHrYGoMP0SdMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/unsubscribe/index.vue").then(m => m.default || m)
  },
  {
    name: successILOp9nwjGzMeta?.name ?? "epaper-registrierung-bestaetigt",
    path: successILOp9nwjGzMeta?.path ?? "/epaper/registrierung-bestaetigt",
    meta: {...(successILOp9nwjGzMeta || {}), ...{"lang":"de"}},
    alias: successILOp9nwjGzMeta?.alias || [],
    redirect: successILOp9nwjGzMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/register/success.vue").then(m => m.default || m)
  },
  {
    name: indexm07MYSLHIJMeta?.name ?? "epaper-login",
    path: indexm07MYSLHIJMeta?.path ?? "/epaper/login",
    meta: {...(indexm07MYSLHIJMeta || {}), ...{"lang":"de"}},
    alias: indexm07MYSLHIJMeta?.alias || [],
    redirect: indexm07MYSLHIJMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/login/index.vue").then(m => m.default || m)
  },
  {
    name: indexzKa5HA6SYcMeta?.name ?? "epaper-registrierung",
    path: indexzKa5HA6SYcMeta?.path ?? "/epaper/registrierung",
    meta: {...(indexzKa5HA6SYcMeta || {}), ...{"lang":"de"}},
    alias: indexzKa5HA6SYcMeta?.alias || [],
    redirect: indexzKa5HA6SYcMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/register/index.vue").then(m => m.default || m)
  },
  {
    name: archive_45magazineUYQ91wUO7YMeta?.name ?? "magazine-archives",
    path: archive_45magazineUYQ91wUO7YMeta?.path ?? "/epaper/magazin-archiviert",
    meta: {...(archive_45magazineUYQ91wUO7YMeta || {}), ...{"lang":"de"}},
    alias: archive_45magazineUYQ91wUO7YMeta?.alias || [],
    redirect: archive_45magazineUYQ91wUO7YMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/epaper-en/archive-magazine.vue").then(m => m.default || m)
  },
  {
    name: whatsapp_45create_45cartPgOFtB9JknMeta?.name ?? "whatsapp-create-cart",
    path: whatsapp_45create_45cartPgOFtB9JknMeta?.path ?? "/whatsapp/cart",
    meta: {...(whatsapp_45create_45cartPgOFtB9JknMeta || {}), ...{"lang":"de"}},
    alias: whatsapp_45create_45cartPgOFtB9JknMeta?.alias || [],
    redirect: whatsapp_45create_45cartPgOFtB9JknMeta?.redirect || undefined,
    component: () => import("/builds/develop/ia-ns-frontend-web-ihreapothekende/app/pages/whatsapp-create-cart.vue").then(m => m.default || m)
  }
]